import { z } from "zod";
import { INCIDENT_CATEGORY, DESCRIPTION } from "./consts";

export const schema = z.object({
  [INCIDENT_CATEGORY]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddFormValues = z.infer<typeof schema>;
